<template>
	<div class="manager-info-view">
		<div class="info mt-10">
			<div class="data">
				<div class="tables vx-row">
					<div class="vx-col mb-10">
						<div class="manager-block flex">
							<div class="photo">
								<img :src="model.photo" alt="">
							</div>
							<div class="flex flex-col justify-between">
								<table>
									<tbody>
									<tr>
										<td class="manager-info-view__name">
											{{ model.first_name }} {{ model.last_name }}
										</td>
									</tr>
									<tr>
										<td>{{ model.email }}</td>
									</tr>
									<tr>
										<td>{{ model.phone }}</td>
									</tr>
									</tbody>
								</table>
								<vs-button
									@click="$router.push($route.path+'/edit')"
									class="manager-info-view__edit"
								>{{ $t('edit') }}</vs-button>
							</div>
						</div>
					</div>
					<table class="vx-col w-full md:w-1/2 mb-10">
						<tbody>
						<tr>
							<td>{{ $t('emailForPayment') }}</td>
							<td>{{ model.email_payment }}</td>
						</tr>
						<tr>
							<td>{{ $t('emailAliasManager') }}</td>
							<td>{{ model.emailAlias }}</td>
						</tr>
						<tr>
							<td>{{ $t('birthDate') }}</td>
							<td>{{ birthDateOutput }}</td>
						</tr>
						<tr>
							<td>{{ $t('sex') }}</td>
							<td>{{ $getDeep(model.gender, genders) }}</td>
						</tr>
						<tr>
							<td>{{ $t('country') }}</td>
							<td>{{ $getDeep(model.country, countries) }}</td>
						</tr>
						<tr>
							<td>{{ $t('language') }}</td>
							<td>
								<div class="d-flex flex-wrap">
									{{ languagesOutput }}
								</div>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ManagerInfo",
	props: {
		model: { required: true },
		languages: { type: Array, default: () => [] },
		genders: { type: Array, default: () => [] },
		countries: { type: Array, default: () => [] },
	},
	computed: {
		birthDateOutput() {
			if(!this.model === undefined || !this.model.birth_date) return null;

			return this.model.birth_date
				.split('-')
				.reverse()
				.join('.');
		},
		languagesOutput() {
			if(!this.model === undefined || !this.model.languages) return null;

			let output = [];
			for(let lang of this.model.languages) {
				output.push(this.$getDeep(lang, this.languages));
			}
			return output.join(", ");
		},
	}
};
</script>

<style lang="scss">
.manager-info-view {
	&__name {
		font-size: 18px;
		font-weight: 700;
	}

	.tables {
		display: flex;
		justify-content: space-between;
	}

	table:last-child {
		padding-left: 15px;

		tr {

			td {
				padding-bottom: 7px;

				&:first-child {
					width: 250px;
					font-weight: 600;

					@media screen and (max-width: 768px) {
						width: 175px;
					}
				}
			}

		}
	}

	.info {
		display: flex;

		.about {
			display: flex;
			margin-left: 20px;

			b {
				flex-shrink: 0;
				width: 250px;
			}
		}
	}

	.photo {
		width: 150px;
		height: 150px;
		border-radius: 10px;
		overflow: hidden;
		margin-left: 0;
		flex-shrink: 0;
		margin-right: 25px;


		img {
			max-width: 100%;
			width: 100%;
			height: 100%;
		}
	}

	.data{
		width: 100%;
	}

	@media screen and (max-width: 470px) {
		.manager-block {
			flex-direction: column;
		}

		.photo {
			width: 220px;
			height: 220px;
			margin-right: 0;
			margin-bottom: 20px;
		}

		&__edit {
			margin-top: 10px;
		}
	}
}
</style>
